import { useEffect, useState } from "react";
import { HiMenuAlt3 } from "react-icons/hi";
import logo from "../assets/logo.png";

const Navbar = () => {
  const [nav, setNav] = useState(false);

  const [activeLink, setActiveLink] = useState(""); // Track selected menu

  const handleNav = () => setNav(!nav);

  const handleLinkClick = (link) => {
    console.log("Link clicked:", link);
    setActiveLink(link);
    setNav(false); // close mobile menu after click
  };
  useEffect(() => {
    const curr = window.location.pathname.split("/")[1];
    setActiveLink(curr);
  }, []);

  const menuItems = [
    { name: "Pathyacharya", href: "pathyacharya" },
    { name: "Live Test", href: "live-test" },
    { name: "App Tutorial", href: "blog" },
    { name: "For Schools", href: "smart" },
    { name: "Highlights", href: "impact" },
  ];

  return (
    <nav className="w-full fixed flex items-center justify-between px-4 sm:px-8 lg:px-12 xl:px-16 2xl:px-20 py-2 top-0 left-0 z-20 h-[60px] shadow-[0_4px_4px_rgba(0,0,0,0.1)] bg-white">
      {/* Logo */}
      <a href="/">
        <img src={logo} alt="Schooglink" className="h-[38px] w-[18px] mr-32" />
      </a>

      {/* Desktop Nav */}
      <div className="hidden sm:flex gap-6 md:gap-8 lg:gap-12 xl:gap-[72px]">
        {menuItems.map((item) => (
          <a
            key={item.href}
            href={item.href}
            onClick={() => handleLinkClick(item.href)}
            className={`transition-colors duration-200 ${
              activeLink === item.href
                ? "font-bold text-black-600"
                : "font-normal text-black-500 hover:font-bold"
            }`}
          >
            {item.name}
          </a>
        ))}
      </div>

      {/* Mobile Toggle */}
      <div className="sm:hidden z-30" onClick={handleNav}>
        <HiMenuAlt3 className="text-black cursor-pointer" size={28} />
      </div>

      {/* Mobile Nav Menu */}
      <div
        className={`fixed top-0 left-0 w-screen h-screen bg-black/90 z-40 transform ${
          nav ? "translate-x-0" : "-translate-x-full"
        } transition-transform duration-300 ease-in-out`}
      >
        <ul className="flex flex-col items-center justify-center h-full gap-10 text-2xl text-white">
          {menuItems.map((item) => (
            <li key={item.href}>
              <a
                href={item.href}
                onClick={() => handleLinkClick(item.href)}
                className={`transition-colors duration-200 ${
                  activeLink === item.href
                    ? "font-bold text-yellow-400"
                    : "font-normal text-white hover:text-yellow-300"
                }`}
              >
                {item.name}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
